export const TABS_KEY = {
  tools: 'tools',
};

export const DOCUMENTS_TYPE = {
  WIKI: 'wiki',
};
